/**
 * Model that represents our type settings groups.
 * 
 * @package Ninja Forms builder
 * @subpackage Fields
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'models/app/settingGroupModel',[], function() {
	var model = Backbone.Model.extend( {
		defaults: {
			display: false
		}
	} );
	
	return model;
} );
